import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as authActions from './../../redux/modules/auth';
import {push} from 'react-router-redux';
var styles=require('./MenuBar.less');
import './rc-menu.css';
import * as commonActions from './../../actions/commonActions';
import * as dashboardActions from './../../actions/dashboardActions';
import AddWidget from '../AddWidget/AddWidgetComponent';
import Setting from '../Setting/SettingComponent';
import LayoutComponent from '../LayoutComponent/LayoutComponent';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as changePasswordActions  from './../../actions/changePasswordActions';
import * as activityActions from './../../actions/activityActions';
import * as reportActions from './../../actions/reportActions';
import Version from '../MenuBar/Version';
import ChangePasswordSettingComponent from '../ChangePassword/ChangePasswordSettingComponent';
import Modal from 'react-modal';
import {Button, ButtonToolbar, DropdownButton, MenuItem} from 'react-bootstrap';
import appConstants from './../../appConstants';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import LogoutComponent from '../Logout/LogoutComponent';
import OutsideAlerter from "../HelperComponents/OutsideAlerter";
import i18next from 'i18next';
import $ from 'jquery';
import { applyStyle, applyClickActive, applyToHover,setDirection, setThemedLogo } from './../../utils/utils';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
import MUIIcon from '../../components/IconMaterialUI/MUIIcon';
let unlockFlag = 0;

const elementsData = [
  {"classNames":"hoverDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"prflLbl","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"profileWrapper","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dropDownList","elementType":"tag", "applyTo":"all", "tagNames":"a"},
  {"classNames":"popbutton","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"menuIcon","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"repIcon","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"homeIcon","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"addIcon","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"addDisabled","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"prflIcon","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"navbar-inverse","elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"navItemLabel","elementType":"normal", "applyTo":"all", "tagNames":"p"},
  {"classNames":"dropdown_menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"profileMenu", "elementType":"normal", "applyTo":"single", "tagNames":"li"},
  {"classNames":"profileButton", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"settingDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"inputField", "elementType":"normal", "applyTo":"all", "tagNames":"input"},
  {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"menulayoutDropdown","elementType":"tag", "applyTo":"all", "tagNames":"button"},
  {"classNames":"toolTip","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"type-dark","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"wlcmMenu","elementType":"normal", "applyTo":"single", "tagNames":"li"},
  {"classNames":"userMenuList","elementType":"normal", "applyTo":"all", "tagNames":"li"},
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"subHeader", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"subHeaderLbl", "elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"userMenuActv", "elementType":"normal", "applyTo":"all", "tagNames":"li"},
  {"classNames":"accLabel", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"btnWrap", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"msgWrap", "elementType":"normal", "applyTo":"all", "tagNames":"div"}
];

const directionData=[
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"navbar-collapse","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"navbar-header","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"lockDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"profileWrpDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"pwdDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"lockBtnDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"profileButton", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"Tempcheckbox","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"Savebutton_grp","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"profileList","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"prflLbl","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"btnText", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"menuList","elementType":"normal", "applyTo":"all", "tagNames":"li"},
  {"classNames":"saveP","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"AddressDir","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"versionN","elementType":"normal", "applyTo":"all", "tagNames":"li"},
];

@connect(state => ({
  userDetail:state.auth.userDetail,
  loginTime:state.auth.loginTime,
  ACD:state.auth.ACD,
  DFA:state.auth.DFA,
  status:state.dashboardRoot.dashboardReducer.status,
  ratesStatus:state.dashboardRoot.instrumentListReducer.status,
  message:state.auth.message,
  tempList:state.dashboardRoot.dashboardReducer.tempList,
  layout:state.dashboardRoot.dashboardReducer.layout,
  tradeBookColumns:state.dashboardRoot.dashboardReducer.tradeBookColumns,
  deleteWidgetKey:state.dashboardRoot.dashboardReducer.deleteWidgetKey,
  sessionTimeOut:state.dashboardRoot.dashboardReducer.sessionTimeOut,
  internalServerError:state.dashboardRoot.dashboardReducer.internalServerError,
  handler:state.dashboardRoot.commonReducer.handler,
  forcedLogout:state.dashboardRoot.commonReducer.forcedLogout,
  defAcc:state.dashboardRoot.dashboardReducer.defAcc,
  addWidgetFlag:state.dashboardRoot.dashboardReducer.addWidgetFlag,
  enableflag:state.dashboardRoot.dashboardReducer.enableflag,
  loadLockFlag:state.dashboardRoot.commonReducer.loadLockFlag,
  setLockState:state.dashboardRoot.commonReducer.setLockState,
  language:state.dashboardRoot.commonReducer.language,
  logoutFlag:state.dashboardRoot.dashboardReducer.logoutFlag,
  unlockErrorMsg:state.dashboardRoot.commonReducer.unlockErrorMsg,
  userProfileFlag:state.auth.userProfileFlag,
  selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  isprofileFlags:state.dashboardRoot.commonReducer.isprofileFlag,
  navigationStatus:state.dashboardRoot.commonReducer.navigationStatus,
  layoutModal:state.dashboardRoot.dashboardReducer.layoutModal,
  unlockScreenFlag:state.dashboardRoot.commonReducer.unlockScreenFlag,
  checkLockFlag:state.dashboardRoot.commonReducer.checkLockFlag,
  showProfileFlag:state.dashboardRoot.dashboardReducer.showProfileFlag,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  configInfo:state.auth.configInfo,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  versionDetails:state.dashboardRoot.dashboardReducer.versionDetails,
  orderStatus:state.dashboardRoot.tradepanelReducer.orderStatus,
  versionList:state.dashboardRoot.dashboardReducer.versionList,
  loadAllRate:state.dashboardRoot.instrumentListReducer.loadAllRate,
  selectedTheme:state.auth.selectedTheme,
  biometricDeviceList:state.dashboardRoot.dashboardReducer.biometricDeviceList,
  deRegisterRandom:state.dashboardRoot.dashboardReducer.deRegisterRandom
}), {
  pushState: push,
  ...commonActions,
  ...dashboardActions,
  ...tradepanelActions,
  ...instrumentListActions,
  ...activityActions,
   ...reportActions,
   ...changePasswordActions,
   ...authActions
})
class MenuBarComponent extends Component {
  constructor(props){
    super(props);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.timer =null;
  }
  static propTypes = {
    userDetail:PropTypes.object,
    logout:PropTypes.func.isRequired,
    pushState:PropTypes.func.isRequired,
    message:PropTypes.string,
    status:PropTypes.string,
    saveTemplate:PropTypes.func,
    layout:PropTypes.array,
    sessionTimeOut:PropTypes.bool,
    internalServerError:PropTypes.bool,
    navigationTradeReport:PropTypes.func,
    closeSocketData:PropTypes.func.isRequired,
    closeSocketTrade:PropTypes.func.isRequired,
    handler:PropTypes.array,
    hidePopup:PropTypes.func,
    handleModal:PropTypes.func,
    handleSettingModal:PropTypes.func,
    tempList:PropTypes.array,
    tradeBookColumns:PropTypes.object,
    forcedLogout:PropTypes.bool,
    resetState:PropTypes.func.isRequired,
    addWidgetFlag:PropTypes.bool,
    addWidgetmodalflag:PropTypes.func,
    enableflag:PropTypes.bool,
    loadLockFlag:PropTypes.func,
    setLockState:PropTypes.bool,
    resetStateReportData:PropTypes.func,
    language:PropTypes.string,
    ratesStatus:PropTypes.string,
    deleteWidgetKey:PropTypes.array,
    setLogoutFlag:PropTypes.func,
    logoutFlag:PropTypes.bool,
    resetStateLogout:PropTypes.func,
    userProfileFlag:PropTypes.bool,
    navigationStatus:PropTypes.string,
    layoutModal:PropTypes.bool,
    setLayoutFlag:PropTypes.func,
    unlockScreenFlag:PropTypes.bool,
    setUnlockModal:PropTypes.func,
    checkLockFlag:PropTypes.bool,
    checkLockStatus:PropTypes.func,
    showProfileFlag:PropTypes.bool,
    setShowProfileFlag:PropTypes.func,
    getVersionDetails:PropTypes.func,
    versionDetails:PropTypes.string,
    loadAllRate:PropTypes.bool,
    loadAllRateData:PropTypes.func,
    biometricDeviceList:PropTypes.object,
    deregisterDevice:PropTypes.func,
    loadBiometricDevice:PropTypes.func,
    isAllApiLoaded:PropTypes.func,
  }

  state = {
    toggleTrade:true,
    toggleReport:false,
    toogleLayout:false,
    isInstrument:true,
    isMargin:true,
    defaultTempFlag:'',
    resetFlag:false,
    profile:true,
    settingsFlag:false,
    templateName:'selectLayout',
    templatelist:[],
    tempId:'',
    checked:true,
    errorMsg:'',
    defAcc:'',
    radioBtnFlag:true,
    updatelayouterror:'',
    savelayouterror:false,
    showLogoutFlag:false,
    // showProfileFlag:false,
    showLayoutFlag:false,
    saveLayoutFlg:false,
    showBiometricDvcsFlag:false,
    open:false,
    isprofileFlag:false,
    showVersionNumber:false,
    versionDetails:"",
    versionModal:false,
    deregisterModal:false,
    biometricDevList:[],
    tokenId:'',
    deviceType:'',
    successMsg:"",
    successMsgFlag:false,
    deviceName: ''
  }

  componentDidMount(){
    this.props.getTempList();
    // this.props.loadBiometricDevice();
    this.setState({defAcc:this.props.DFA.D});
    const thisComponent = ReactDOM.findDOMNode(this);
    // //const allCssStyleRules = this.props.selectedCssColorTheme;
    // setTimeout(function(){
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    // },5)
    setDirection(thisComponent,directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('userMenuList')[0], "classNames":"userMenuList"},
      {"elmToHover":thisComponent.getElementsByClassName('userMenuList')[1], "classNames":"userMenuList"},
      {"elmToHover":thisComponent.getElementsByClassName('userMenuList')[2], "classNames":"userMenuList"},
      {"elmToHover":thisComponent.getElementsByClassName("profileButton")[0], "classNames":"profileButton"},
      {"elmToHover":thisComponent.getElementsByClassName("profileButton")[1], "classNames":"profileButton"},
      {"elmToHover":thisComponent.getElementsByClassName("popbutton")[0], "classNames":"popbutton"},
      {"elmToHover":thisComponent.getElementsByClassName("popbutton")[1], "classNames":"popbutton"},
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  }

  componentDidUpdate(prevProps){
    const thisComponent = ReactDOM.findDOMNode(this);
    // //const allCssStyleRules = this.props.selectedCssColorTheme;
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(thisComponent,directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('userMenuList')[0], "classNames":"userMenuList"},
      {"elmToHover":thisComponent.getElementsByClassName('userMenuList')[1], "classNames":"userMenuList"},
      {"elmToHover":thisComponent.getElementsByClassName('userMenuList')[2], "classNames":"userMenuList"},
      {"elmToHover":thisComponent.getElementsByClassName("profileButton")[0], "classNames":"profileButton"},
      {"elmToHover":thisComponent.getElementsByClassName("profileButton")[1], "classNames":"profileButton"},
      {"elmToHover":thisComponent.getElementsByClassName("popbutton")[0], "classNames":"popbutton"},
      {"elmToHover":thisComponent.getElementsByClassName("popbutton")[1], "classNames":"popbutton"},
    ];
   // //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  }

  componentWillMount() {
    this.props.navigationTradeReport('trade');
  }

  componentWillReceiveProps(nextProps, nextState){
    // const thisComponent = ReactDOM.findDOMNode(this);
    // const allCssStyleRules = nextProps.selectedCssColorTheme;
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    if(this.props.versionDetails !== nextProps.versionDetails){
      this.setState({versionDetails:nextProps.versionDetails});
    }
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   setTimeout(function(){
    //     applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   },5)
    // }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
    if(nextProps.unlockErrorMsg !== this.state.errorMsg){
        this.setState({errorMsg:nextProps.unlockErrorMsg});
    }
    if (nextProps.userProfileFlag === nextProps.showProfileFlag) {
      // this.setState({showProfileFlag:false});
      this.props.setShowProfileFlag(false);
    }
    //withClickOutside div
    /*if (nextProps.outside !== this.props.outside) {
      this.setState({
        showProfileFlag:!nextProps.outside,
      });
      //setTimeout(function(){
        applyStyle(thisComponent, allCssStyleRules, elementsData);
      //},600);
    }*/
    if(nextProps.DFA.D !== this.props.DFA.D){
        this.setState({defAcc:nextProps.DFA.D});
    }
    if(nextProps.tempList !== this.props.tempList){
      const templist = [];
      let tempArr = [];
      for (let index = 0; index < nextProps.tempList.length; index++) {
        templist.push(nextProps.tempList[index]);
        tempArr.push(nextProps.tempList[index].N);
      }
      this.setState({templatelist:templist});
      this.setState({tempArr:tempArr});
      if(nextProps.tempList.length !== 0){
        this.setState({tempId:templist[0].C});
      }
      //this.setState({defaultTempFlag:templist[0].isDef});
    }
    if(nextProps.setLockState !== this.props.setLockState){
      if(nextProps.setLockState === 1)
        this.props.setUnlockModal(false);
    }
    if(nextProps.navigationStatus!==this.props.navigationStatus){
      if(nextProps.navigationStatus==='trade'){
          this.props.addWidgetmodalflag(true);
      }
      const thisComponent = ReactDOM.findDOMNode(this);
      // const allCssStyleRules = nextProps.selectedCssColorTheme;
      // setTimeout(function(){
      //   applyStyle(thisComponent, allCssStyleRules, elementsData);
      // },5)
    }
    this.setState({toggleTrade:true});
    this.setState({toggleReport:false});
    this.setState({toggleLayout:false});
    if(this.props.deRegisterRandom !== nextProps.deRegisterRandom){
        this.props.loadBiometricDevice();
        this.setState({successMsg:'biometricDergisterSuccess'});
        this.setState({successMsgFlag:true});
      }

    if(this.state.biometricDevList !==nextProps.biometricDeviceList){
        this.setState({biometricDevList:nextProps.biometricDeviceList})
      }
  }

  handleLogout = () => {
    try{
      this.props.closeforcedModal();
      this.props.closeSocketData();
      this.props.closeSocketTrade();
      const {handler} = this.props;
      if (handler) {
        for (let currWindow = 0; currWindow < handler.length; currWindow++) {
          handler[currWindow].close(); // to close all popuped out widgets.
        }
      }
      this.props.resetState();
      this.props.loadTemplateFlag(false);
      localStorage.setItem('logoutClose',true);
      this.props.clearHeartRateInterval();
      this.props.clearHeartOrdInterval();
      // this.props.resetStateSocket();
      this.props.resetStateLogout();
      this.props.isAllApiLoaded(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleLogout', component:"MenuBarComponent"});
    }
  }

  selectOption = (option) => {
    try {
      let flag;
      this.props.loadAllRateData(false);
      if (option === 'trade') {

        this.setState({ toggleTrade: true, toggleReport: false, toggleLayout: false });
        flag = true;
        this.props.layoutflag(false);
        this.props.resetStateReportData();
        // this.setState({showProfileFlag:false});
        this.props.setShowProfileFlag(false);
        this.props.navigationTradeReport(option);

      } else if (option === 'report') {

        this.setState({ toggleReport: true, toggleTrade: false, toggleLayout: false });
        flag = false;
        this.props.layoutflag(false);
        // this.setState({showProfileFlag:false});
        this.props.setShowProfileFlag(false);
        this.props.navigationTradeReport(option);

      } else if (option === 'layout') {

        //this.props.getTempList();
        this.setState({ toggleLayout: true, toggleReport: false, toggleTrade: false });
        this.props.layoutflag(true);
        this.props.resetStateReportData();
        flag = false;
        // this.setState({showProfileFlag:false});
        this.props.setShowProfileFlag(false);
        this.setState({ showLayoutFlag: false, saveLayoutFlg: false });
        this.props.navigationTradeReport(option);
      
      } else if (option === 'delivery') {

        this.props.navigationTradeReport(option);
        flag = false;

      } else if (option === 'version') {

        this.setState({ toggleLayout: false, toggleReport: false, toggleTrade: false });
        flag = false;
        this.props.layoutflag(false);
        // this.setState({showProfileFlag:false});
        this.props.setShowProfileFlag(false);
        this.props.navigationTradeReport(option);

      }
      this.props.addWidgetmodalflag(flag);
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'selectOption', component: "MenuBarComponent" });
    }
  }

  closeunlockModal = (event) => {
    try{
      this.props.setUnlockModal(false);
      this.setState({errorMsg:''});
      clearTimeout(this.timer);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeunlockModal', component:"MenuBarComponent"});
    }
  }

  handleUnlock = (event) => {
    try{
      if (this.refs.enterpass.value) {
        this.props.unlockVerify(this.refs.enterpass.value);
      } else {
        this.setState({errorMsg:"pwdNotBlankMsg"});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleUnlock', component:"MenuBarComponent"});
    }
  }
  onKeyPress =(event) =>{
    try{
      if(event.which===13){
        if (this.refs.enterpass.value){
          this.props.unlockVerify(this.refs.enterpass.value);
          event.preventDefault();
        } else {
          this.setState({errorMsg:"pwdNotBlankMsg"});
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onKeyPress', component:"MenuBarComponent"});
    }
  }

  onKeyUp =(event) =>{
    try{
      if(event.which !==13){
        this.setState({errorMsg:""});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onKeyUp', component:"MenuBarComponent"});
    }
  }

  preventSubmit=(event)=>{
    try{
      event.preventDefault();
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'preventSubmit', component:"MenuBarComponent"});
    }
  }

  saveTemplatebyForced = () =>{
    try{
      let isDefault=1;
      let layout=this.props.layout;
      let tempName;
      let tempCode;
      tempName=this.props.tempList[0].N;
      tempCode=this.props.tempList[0].C;
      this.props.saveTemplate(layout,this.props.tradeBookColumns, tempName,tempCode, isDefault,"E");
      this.handleLogout();
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'saveTemplatebyForced', component:"MenuBarComponent"});
    }
  }

  onClickAddWidget = () => {
    try{
      let addInstrument = true;
      let addMargin = true;
      const {deleteWidgetKey, layout} = this.props;
      const layoutArray = layout;
      if (deleteWidgetKey && layoutArray) {
        deleteWidgetKey.forEach((item) => {
          layoutArray.forEach((element, index) => {
            if (item === element.i) {
              layoutArray.splice(index, 1);
            }
          });
        });
      }
      if (layoutArray) {
        layoutArray.map((item) => {
          let str = item.i;
          str = str.substring(0, str.indexOf('-'));
          if (str === 'Instrument') {
            addInstrument = false;
          }
          if (str === 'Margin') {
            addMargin = false;
          }
        });
      }
      this.setState({isInstrument:addInstrument});
      this.setState({isMargin:addMargin});
      this.props.handleModal(true);
      // this.setState({showProfileFlag:false});
      this.props.setShowProfileFlag(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onClickAddWidget', component:"MenuBarComponent"});
    }
  }

  closeModal = () => {
    try{
      //localStorage.setItem('user', null);
      this.props.hidePopup();
      this.handleLogout();
      if (this.props.sessionTimeOut === true) {
        this.props.pushState('login');
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeModal', component:"MenuBarComponent"});
    }
  }

  onClickLogout = () => {
    try{
      this.setState({showVersionNumber:false});
      this.setState({resetFlag:false, settingsFlag:false, profile:false});
      this.setState({showLogoutFlag:true});
      this.setState({showSavetmplBtn:false});
      this.props.setLogoutFlag(true);
      // this.props.checkLockFlag= false;
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onClickLogout', component:"MenuBarComponent"});
    }
  }

  showSettings = () => {
    try{
      this.setState({showVersionNumber:false});
      this.setState({resetFlag:false,showLogoutFlag:false});
      this.setState({settingsFlag:true});
      this.setState({profile:false});
      this.setState({showSavetmplBtn:false});
      this.setState({showLayoutFlag:false,saveLayoutFlg:false});
      this.setState({showBiometricDvcsFlag:false});
      this.setState({successMsg:"",successMsgFlag:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'showSettings', component:"MenuBarComponent"});
    }
  }

  resetPwd = () => {
    try{
      this.setState({resetFlag:true});
      this.setState({showVersionNumber:false});
      this.setState({settingsFlag:false,showLogoutFlag:false});
      this.setState({profile:false});
      this.setState({errorMsg :''});
      this.setState({showSavetmplBtn:false});
      this.setState({showLayoutFlag:false,saveLayoutFlg:false});
      this.setState({showBiometricDvcsFlag:false});
      this.setState({successMsg:"",successMsgFlag:false});
      this.setState({successMsg:"",successMsgFlag:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'resetPwd', component:"MenuBarComponent"});
    }
  }

  showProfile = () => {
    try{
      this.setState({resetFlag:false});
      this.setState({showVersionNumber:false});
      this.setState({settingsFlag:false,showLogoutFlag:false});
      this.setState({profile:true});
      this.setState({showSavetmplBtn:false});
      this.setState({showLayoutFlag:false,saveLayoutFlg:false});
      this.setState({showBiometricDvcsFlag:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'showProfile', component:"MenuBarComponent"});
    }
  }

  showLayout = () =>{
    try{
      this.setState({showLayoutFlag:true});
      this.setState({showVersionNumber:false});
      this.setState({resetFlag:false,showLogoutFlag:false});
      this.setState({settingsFlag:false});
      this.setState({profile:false});
      this.setState({showSavetmplBtn:false});
      this.setState({showBiometricDvcsFlag:false});
      this.setState({successMsg:"",successMsgFlag:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'showLayout', component:"MenuBarComponent"});
    }
  }
  showBiometricDvcs = () =>{
    try{
      this.props.loadBiometricDevice();
      this.setState({showBiometricDvcsFlag:true});
      this.setState({showVersionNumber:false});
      this.setState({resetFlag:false,showLogoutFlag:false});
      this.setState({settingsFlag:false});
      this.setState({profile:false});
      this.setState({showLayoutFlag:false});
      this.setState({successMsg:"",successMsgFlag:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'showBiometricDvcs', component:"MenuBarComponent"});
    }
  }

  showVersionNumber = () =>{
    try{
      this.props.getVersionDetails(this.props.configInfo.applicationVersion);
      this.setState({showVersionNumber:true});
      this.setState({showLayoutFlag:false});
      this.setState({resetFlag:false,showLogoutFlag:false});
      this.setState({settingsFlag:false});
      this.setState({profile:false});
      this.setState({showSavetmplBtn:false});
      this.setState({showBiometricDvcsFlag:false});
      this.setState({successMsg:"",successMsgFlag:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'showVersionNumber', component:"MenuBarComponent"});
    }
  }

  onSaveTemplate = () => {
    try{
      const {deleteWidgetKey, layout} = this.props;
      if (deleteWidgetKey) {
        deleteWidgetKey.forEach((item) => {
          layout.forEach((element, index) => {
            if (item === element.i) {
              layout.splice(index, 1);
            }
          });
        });
      }
      let isCmdtySelected = true;
      let array = layout;
      array = array.filter(item => {
        return item.name === 'Trade';
      });
      const tradeWithoutCmdty = [];
      array.map((item) => {
        if (!('cmdtyPair' in item)) {
          isCmdtySelected = false;
          tradeWithoutCmdty.push(item.i);
        }
      });
      // to remove trade panel without commodity pair
      if (tradeWithoutCmdty) {
        tradeWithoutCmdty.forEach((item) => {
          layout.forEach((element, index) => {
            if (item === element.i) {
              layout.splice(index, 1);
            }
          });
        });
      }
      let mode;
      let tempName;
      let isDefault;
      if (this.state.radioBtnFlag === true) {
        const templateName = this.refs.templateName;
        tempName = templateName.value;
        if (this.state.defaultTempFlag === true) {
          isDefault = 1;
        }else {
          isDefault = 0;
        }
        if(tempName.trim() === ''){
          this.setState({savelayouterror :true});
          this.setState({updatelayouterror :false});
          this.setState({errorMsg :'layoutNameNotBlankMsg'});
        }
        else if(tempName === ''){
          this.setState({savelayouterror :true});
          this.setState({updatelayouterror :false});
          this.setState({errorMsg :'layoutNameNotBlankMsg'});
        }
        else if(!tempName.match(/^[a-zA-Z0-9]+(?:[\w -]*[a-zA-Z0-9]+)*$/)){
          this.setState({savelayouterror :true});
          this.setState({updatelayouterror :false});
          this.setState({errorMsg :'Please enter valid layout name.'});
        }
        else{
          if(this.state.tempArr.indexOf(tempName) === -1){
            mode="A";
            this.setState({savelayouterror :false});
            this.setState({errorMsg :''});
            this.setState({updatelayouterror :false});
            this.props.saveTemplate(layout,this.props.tradeBookColumns, tempName,"0", isDefault, mode).then(
              response => {
                this.props.getTempList();
                this.props.setShowProfileFlag(false);
              }
            )
            this.setState({saveLayoutFlg:false});
            this.setState({layoutmodal:false});
          }else {
            this.setState({errorMsg :'layoutAlreadyExistMsg'});
            this.setState({errorFlag :true});
            this.setState({savelayouterror :true});
          }
        }
      } else {
        mode="E";
        if (this.state.defaultTempFlag === true) {
          isDefault = 1;
        } else {
          isDefault = 0;
        }
        this.setState({updatelayouterror :false});
        this.setState({savelayouterror :false});
        this.setState({errorMsg :''});
        this.setState({saveLayoutFlg:false});
        this.setState({layoutmodal:false});
        this.props.saveTemplate(layout,this.props.tradeBookColumns, this.state.templateName,this.state.tempId, isDefault, mode).then(
          response => {
            this.props.getTempList();
            this.props.setShowProfileFlag(false);
          }
        )
        this.props.getTempList();
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onSaveTemplate', component:"MenuBarComponent"});
    }
  }

  closeSaveOnLayout = () => {
    try{
      this.setState({saveLayoutFlg:false});
      this.setState({errorMsg:''});
      this.setState({savelayouterror:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeSaveOnLayout', component:"MenuBarComponent"});
    }
  }

  showUserProfileDiv=()=>{
    try{
      this.showSettings();
      this.props.setShowProfileFlag(true);
      // this.setState({showProfileFlag:!this.state.showProfileFlag});
      // console.log("showProfileFlag :"+this.props.showProfileFlag);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'showUserProfileDiv', component:"MenuBarComponent"});
    }
  }

  onClickSaveLayout=()=>{
    try{
      this.setState({saveLayoutFlg:true});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onClickSaveLayout', component:"MenuBarComponent"});
    }
  }

  onchangeTemplateRadioBtn = (event) => {
    try{
      if(event.target.value=== "true"){
        this.setState({radioBtnFlag:true});
        this.setState({updatelayouterror :false});
        this.setState({templateName:"selectLayout"});
        this.setState({defaultTempFlag:false});
      }else{
        this.setState({radioBtnFlag:false});
        this.setState({savelayouterror :false});
        const templist = [];
        for (let index = 0; index < this.props.tempList.length; index++) {
          templist.push(this.props.tempList[index]);
        }
        this.setState({templatelist:templist});
        this.setState({templateName:this.props.tempList[0].N });
        this.setState({tempId:this.props.tempList[0].C});
        this.setState({defaultTempFlag:this.props.tempList[0].isDef});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onchangeTemplateRadioBtn', component:"MenuBarComponent"});
    }
  }

  templateSelection = (tempdata) => {
    try{
      this.setState({templateName:tempdata.N});
      this.setState({tempId:tempdata.C});
      this.setState({defaultTempFlag:tempdata.isDef});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'templateSelection', component:"MenuBarComponent"});
    }
  }

  handleCheckboxChange = (event) => {
    try{
      this.setState({defaultTempFlag:event.target.checked});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleCheckboxChange', component:"MenuBarComponent"});
    }
  }

  lock = () => {
    try{
      this.props.setUnlockModal(false);
      unlockFlag = 1;
      setTimeout(function(){ $('#showTimeout').fadeIn('slow', function(){
                  $('#showTimeout').delay(1000).fadeOut();
                  unlockFlag = 0;
                }); }, 100);
      this.props.loadLockFlag(0);
      //this.props.checkLockStatus(true);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'lock', component:"MenuBarComponent"});
    }
  }

  // unlock = () => {
    // this.props.checkLockStatus(false);
    // this.props.setUnlockModal(true);
  // }

  loadLayout = () =>{
    try{
      this.props.setLayoutFlag(true);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'loadLayout', component:"MenuBarComponent"});
    }
  }

  handleMenuBarLock = () =>{
    try{
    if(this.props.checkLockFlag === true){
      clearTimeout(this.timer);
        this.props.setUnlockModal(true);
        this.timer = setTimeout(() => {
          this.props.setUnlockModal(false);
        }, 1000000);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleMenuBarLock', component:"MenuBarComponent"});
    }
  }

  onClickVersion = () => {
    try{
      this.setState({versionModal:true});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onClickVersion', component:"MenuBarComponent"});
    }
  }

 closeVersionModal  = () => {
  try{
    this.setState({versionModal:false});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'closeVersionModal', component:"MenuBarComponent"});
  }
 }

deregisterConfirmation=(item)=>{
  try{
    this.setState({tokenID:item.tokenID});
    this.setState({deviceType:item.deviceType});
    this.setState({deregisterModal:true, deviceName: item.deviceName});
    this.setState({successMsg:"",  successMsgFlag:false});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'deregisterConfirmation', component:"MenuBarComponent"});
  }
}
acceptDegeistration=()=>{
  try{
    this.setState({deregisterModal:false});
    this.props.deregisterDevice(this.state.tokenID,this.state.deviceType)
    //this.props.setShowProfileFlag(true);///this is to keep Profile open
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'acceptDegeistration', component:"MenuBarComponent"});
  }
}

closeDeregistrationModal=()=>{
  try{
    this.setState({deregisterModal:false});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'closeDeregistrationModal', component:"MenuBarComponent"});
  }
}
closeSuceessModal=()=>{
  try{
    this.setState({deregisterModal:false});
    this.setState({successMsg:"",  successMsgFlag:false});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'closeSuceessModal', component:"MenuBarComponent"});
  }
}
  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      ////const allCssStyleRules = this.props.selectedCssColorTheme;
      const elementsData = [
        {"classNames":"widgetHeader", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"popbutton", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
        {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"widgetTitle", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"mdlWrap", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"form-control", "elementType":"normal", "applyTo":"single", "tagNames":"input"},
        {"classNames":"header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"msg", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"userMenuList","elementType":"normal", "applyTo":"all", "tagNames":"li"},
        {"classNames":"accLabel", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"btnWrap", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"msgWrap", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"lmtClose","elementType":"normal", "applyTo":"all", "tagNames":"button"},
      ];

      //applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData =[
        {"classNames":"pwdDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"lockBtnDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon","elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"profileButton", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
        {"classNames":"Tempcheckbox","elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"Savebutton_grp","elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"lmtClose","elementType":"normal", "applyTo":"all", "tagNames":"button"},
      ];

      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName('userMenuList')[0], "classNames":"userMenuList"},
        {"elmToHover":thisComponent.getElementsByClassName('userMenuList')[1], "classNames":"userMenuList"},
        {"elmToHover":thisComponent.getElementsByClassName('userMenuList')[2], "classNames":"userMenuList"},
        {"elmToHover":thisComponent.getElementsByClassName("popbutton")[0], "classNames":"popbutton"},
        {"elmToHover":thisComponent.getElementsByClassName("popbutton")[1], "classNames":"popbutton"},
        {"elmToHover":thisComponent.getElementsByClassName('dropDownList')[0], "classNames":"dropDownList"},
        {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"},
        {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[1], "classNames":"lmtClose"}
      ];
      ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"MenuBarComponent"});
    }
  }

  render() {
    var show_trdDetails;
    if (this.props.sessionTimeOut === true) {
      this.props.pushState('login');
    }
    if (this.props.message && this.props.message === 'User logged out successfully' && !this.props.user) {
      localStorage.setItem('user', null);
      this.props.pushState('login');
    }

    const {templateName} = this.state;
    const tempId = this.state;
    const user = this.props.userDetail;
    const checked = this.state;
    var LoggedInTimeDate ="";
    var userName = "";
    if(user !== null){
      if(user.LoggedInTime === null || user.LoggedInTime === "" || user.LoggedInTime === "null"){
        LoggedInTimeDate="";
      }else{
        LoggedInTimeDate=moment.utc(user.LoggedInTime).local().format(appConstants.loginDateFrmat);
      }
      userName = user.traderCode;
    }
    const dataTooltip1 = i18next.t("livePricing");
    const dataTooltip2 = i18next.t("termNetDown");
    const dataTooltip3 = i18next.t("priceFeedDown") + " | " + i18next.t("orderSessionDown");
    const dataTooltip4 = i18next.t("priceFeedDown");
    const dataTooltip5 = i18next.t("orderSessionDown");
    const dataTooltip6 = i18next.t("rateServerDown");
    const dataTooltip7 = i18next.t("orderServerDown");
    //var showNote=this.state.versionDetails !== undefined && this.state.versionDetails!=="" ? JSON.parse(this.state.versionDetails.versionData[0].ReleaseNote) : null;
    let trader=user.ShowTrdCodeDesc;
    if(trader==="${Trader_Description}") {
      show_trdDetails=trader.replace("${Trader_Description}",user.UD)
    } else if(trader==="${Trader_Code}"){
      show_trdDetails=trader.replace("${Trader_Code}",user.traderCode)
    } else{
     trader=trader.replace("${Trader_Code}",user.traderCode)
     show_trdDetails=trader.replace("${Trader_Description}",user.UD)
    }

    const LOCATION = this.props.configInfo.locationDesc
    const env = this.props.configInfo && this.props.configInfo.isProd === false ? 'dev' : 'production';
    
    const closeIcon = <MUIIcon icon={'Close'} className={`dp48 closeBtn commonCloseIcon`}/>
    return (
      <div>
        <Modal isOpen={this.props.internalServerError} className={styles.warningModal} contentLabel="Example Modal" id="layoutErrorModal">
          <div className={`${styles.header} header`}>
            <sapn className={`${styles.closeicon}`} onClick={this.closeModal}>
              <MUIIconWithTooltip icon={'Close'} className={`dp48 closeBtn commonCloseIcon`} title={i18next.t("close")} />
            </sapn>
          </div>
          <div className={`${styles.msgWrap} msgWrap`}>
            <h4>{i18next.t('internalServErr')}</h4>
          </div>
        </Modal>

        <Modal isOpen={this.state.deregisterModal} className={styles.tmpl_content} contentLabel="Example Modal" id="menuSettingModal" onAfterOpen={this.afterOpenModal}>
          <div ref="errorMSG" className={`${styles.deRegisterDiv} mdlWrap`} >
          <div className={`${styles.header} header`}>
            <span className={styles.msgTitle}>{i18next.t("Confirmation")}</span>
              <span className={`${styles.closeicon}`} id="closeModalIcon" onClick={this.closeDeregistrationModal}>
                {closeIcon}
              </span>
            </div>
            <div className={`${styles.msgWrap} msgWrap`}>
              <h4>{i18next.t('ConformationBiometric') + this.state.deviceName.trim() + '. Proceed?'}</h4>
            </div>
            <div className={`${styles.btnWrap} col-md-12`}>
            <Button id="biometricCanBtn" onClick={this.closeDeregistrationModal} className="lmtClose">{i18next.t("no")}</Button>&nbsp;&nbsp;
            <Button id="biometricConfBtn" className='button-l lmtClose' onClick={this.acceptDegeistration}>{i18next.t("yes")}</Button>
            </div>
          </div>
        </Modal>
        <Modal isOpen={this.state.successMsgFlag} className={styles.tmpl_content} contentLabel="Example Modal" id="menuSettingModal" onAfterOpen={this.afterOpenModal}>
          <div ref="errorMSG" className={`{styles.forcedLogoutDiv} mdlWrap`} >
          <div className={`${styles.header} header`}>
            <span className={styles.msgTitle}>{i18next.t("Confirmation")}</span>
              <span className={`${styles.closeicon}`} id="closeModalIcon" onClick={this.closeSuceessModal}>
                {closeIcon}
              </span>
            </div>
            <div className={`${styles.msgWrap} msgWrap`}>
              <h4>{i18next.t(this.state.successMsg)}</h4>
            </div>
          </div>
        </Modal>

        {this.props.addWidgetFlag === true  ?
          <AddWidget props={this.props.language} isInstrument={this.state.isInstrument} isMargin={this.state.isMargin} />
        : null}

        {this.state.settingmodal === true ?
          <Setting props={this.props.language} />
        : null}

        {this.props.layoutModal === true ?
          <LayoutComponent props={this.props.language} />
        : null}

        <div>
          {(unlockFlag === 1) ?
            <div className={styles.lockDiv} id="showTimeout">
              <h3>{i18next.t("screenLocked")}</h3>
            </div>
          : ((unlockFlag === 2) ?
            <div className={styles.lockDiv} id="showTimeout">
              <h3>{i18next.t("screenUnlocked")}</h3>
            </div>
          : null)}
        </div>

        <div className={styles.headerMain}>
          <div className="container navbar-fixed-top" onClick={this.handleMenuBarLock}>
            <nav className={styles.neonavbar + ' navbar navbar-inverse'} role="navigation" id="onresizeNavCss">
              <div className="container-fluid menuBarLeft">
                <div className="col-sm-12 menuBarLeft">
                  <div className="navbar-header">
                    <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" id="toggleBtnCss">
                      <span className="sr-only">{i18next.t("toggleNavigation")}</span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </button>
                    <ul className={this.props.checkLockFlag === true ? `${styles.setLockClass} ${styles.logo_ul}` : `${styles.setUnlockClass} ${styles.logo_ul}`}>
                      <li className={`${styles.logo_obj}`}>
                        {/*<a className={`${styles.logo}`} onClick={() => this.selectOption('trade')} id="ntpLogo">*/}
                        <img 
                            height="82px" 
                            src={setThemedLogo(LOCATION, this.props.selectedTheme, env)} 
                            onError={e => setThemedLogo(LOCATION, this.props.selectedTheme, env, 'dark', e)} 
                        />
                        {/*</a>*/}
                      </li>
                    </ul>
                  </div>

                  {this.props.configInfo.showheaderaddress !== undefined && this.props.configInfo.showheaderaddress === true &&
                    <div className="AddressDir">
                      <div className={`${styles.AddressDiv} AddressDiv`}>
                        <div className={styles.AddHead}>LH PRECIOUS METALS INVESTMENT PTE LTD</div>
                        <div>24 Raffles Place, #24-02B Clifford Centre</div>
                        <div>Singapore 048621</div>
                        <div>Tel: (65) 6535 0180 | Fax: (65) 6535 0182</div>
                        <div>Email: ops@lhpreciousmetals.com</div>
                      </div>
                    </div>
                  }

                  <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                    <div className="lockmsgdiv">
                      {this.props.setLockState === 0 ?
                        <div className={styles.lockMsgDiv}>
                          <h3> {i18next.t("screenLocked")} </h3>
                        </div>
                      : null}
                    </div>

                    <ul className={`${styles.neorightnav} nav navbar-nav navbar-right ${this.props.selectedCssColor}`} id="menubaricons" >
                      <li className={this.props.checkLockFlag === true ? `${styles.setLockClass}` : `${styles.setUnlockClass}`} onClick={() => this.selectOption('trade')} id="homeMenu">
                        <div>
                          <span className={"menuIcon homeIcon"}>
                          </span>
                          <p className={styles.navItemLabel}>
                            {i18next.t('home')}
                          </p>
                        </div>
                      </li>

                      <li className={this.props.addWidgetFlag === false ? `${styles.disabled}`:this.props.setLockState === 0 ? `${styles.setLockClass}` : `${styles.setUnlockClass}`} onClick={this.onClickAddWidget} id="addMenu">
                        <div>
                          {this.props.addWidgetFlag === true ?
                            <span className="menuIcon addIcon"> </span>
                          :
                            <span className="menuIcon addDisabled"> </span>
                          }
                          <p className={styles.navItemLabel}>{i18next.t('add')}</p>
                        </div>
                      </li>

                      <li className={this.props.checkLockFlag === true ? `${styles.setLockClass}` : `${styles.setUnlockClass}`} onClick={() => this.selectOption('report')} id="homeMenu">
                        <div>
                          <span className={"menuIcon repIcon"}>
                          </span>
                          <p className={styles.navItemLabel}>
                            {i18next.t('reports')}
                          </p>
                        </div>
                      </li> 

                      {this.props.userDetail.isPhysicalDeliveryEnabled ?
                        <li
                          className={this.props.setLockState === 0
                            ? `${styles.setLockClass}`
                            : `${styles.setUnlockClass}`}
                          onClick={() => this.selectOption('delivery')}
                          id="deliveryMenu">
                          <div>
                            <span className="menuIcon deliveryIcon"> </span>
                            <p className={styles.navItemLabel}>{i18next.t('delivery')}</p>
                          </div>
                        </li> : null
                      }

                      <li className={this.props.setLockState === 0 ? `${styles.setLockClass} ${styles.userprofile} ${styles.divider}` : `${styles.setUnlockClass} ${styles.userprofile} ${styles.divider}`} style={this.props.selectedLang.divider}>
                        <div id={this.props.id}>
                          <span className="menuIcon prflIcon" onClick={this.showUserProfileDiv}> </span>
                          <p className={styles.navItemLabel} onClick={this.showUserProfileDiv}>{i18next.t('profile')}</p>
                          {this.props.showProfileFlag && (
                            <OutsideAlerter>
                              <div className={`${styles.dropdownWrapper} dropdown`}>
                                <div className={`${styles.profile_wrapper} profileWrpDiv ${this.props.language}`}>
                                  <ul className={`${styles.usermenu} ${styles.dropdown_menu} dropdown-menu usermenu`} role="menu" aria-labelledby="menu1" id="usermenuProfile">
                                    <li role="presentation" onClick={this.showSettings} id="hoverSettingPg" className={this.state.settingsFlag === true ? `${styles.userMenuActv}` : `userMenuList menuList`}>
                                      {i18next.t('settings')}
                                    </li>

                                    <li role="presentation" onClick={this.resetPwd} id="hoverChangePsdPg" className={this.state.resetFlag === true ? `${styles.userMenuActv}` : `userMenuList menuList`}>
                                      {i18next.t('changePwd')}
                                    </li>

                                    <li role="presentation" id="layoutMenu" className={this.state.showLayoutFlag === true ? `${styles.userMenuActv}` : this.props.enableflag === true ? `${styles.disabled} userMenuList menuList` : `userMenuList menuList`} onClick={this.showLayout}>
                                      {i18next.t('layout')}
                                    </li>
                                    
                                    {this.props.userDetail.IsRegDevVisible ?
                                     <li role="presentation" id="biometricMenu" className={this.state.showBiometricDvcsFlag === true ? `userMenuActv` : `userMenuList menuList`} onClick={this.showBiometricDvcs}>
                                      {i18next.t('Registered Devices')}
                                    </li> : null}

                                    { JSON.parse((this.props.versionList[0]).versiondata).length !== 0 ?
                                      <li role="presentation" id="versionNumber" className={`${styles.versionNumberLabel} versionN`} onClick={() => this.onClickVersion()}>
                                        <a title="View Version History">
                                            {i18next.t('version')}{" "}{this.props.userDetail.versionNo}
                                        </a>
                                      </li>
                                    :
                                      <li role="presentation" id="versionNumber" className={`${styles.versionNumberLabel} ${styles.normalText} versionN`}>{i18next.t('version')}{" "}{this.props.userDetail.versionNo}</li>
                                    }
                                  </ul>

                                  <div className={`${styles.hoverDiv} ${this.props.language}`} id="hoverdivProfile" >
                                    {this.state.settingsFlag === true ? <Setting /> : null}

                                    {this.state.resetFlag === true ? <ChangePasswordSettingComponent /> : null}

                                    {this.state.showVersionNumber === true ?
                                      <div className={`${styles.versionDiv}`}>
                                        {this.state.versionDetails ?
                                          <div className={`${styles.releaseDate}`}>
                                            <label>{i18next.t('releaseDate')}: </label>
                                            <span>
                                              {this.state.versionDetails !== undefined && this.state.versionDetails !== "" ? this.state.versionDetails.versionData[0].ReleaseDate : null}
                                            </span>
                                          </div>
                                        : null}

                                        <div className={`${styles.versionDetails}`}>
                                          {this.state.versionDetails && showNote.features !== undefined ?
                                            <div>
                                              <label className={`${styles.featuresLabel}`}>{i18next.t('features')}:</label>
                                              <ul>
                                                {showNote.features.map((item, index) => {
                                                  return (
                                                    <li className={`${styles.showNote}`}>{item}</li>
                                                  );
                                                })}
                                              </ul>
                                            </div>
                                          : null}

                                          {this.state.versionDetails && showNote.bugFixes !== undefined ?
                                            <div>
                                              <label className={`${styles.featuresLabel}`}>
                                                {i18next.t('bugFixes')}:
                                              </label>
                                              <ul>
                                                {showNote.bugFixes.map((item, index) => {
                                                  return (
                                                    <li className={`${styles.showNote}`}>{item}</li>
                                                  );
                                                })}
                                              </ul>
                                            </div>
                                          : null}
                                        </div>
                                      </div>
                                    : null}

                                    {this.state.showLayoutFlag === true ?
                                      <div id="btnlayout">
                                        <Button onClick={this.loadLayout} className={`${styles.tmpltBtn} profileButton`} id="loadTempBtn">{i18next.t('loadLayouts')}</Button>
                                        <Button onClick={this.onClickSaveLayout} className={`${styles.tmpltBtn} profileButton`} id="saveCurrTempBtn">{i18next.t('saveCurrentLayout')}</Button>
                                        
                                        {this.state.saveLayoutFlg === true ?
                                          <div className={`${styles.saveTempDiv}`} id="savemodel">
                                            <div className={`${styles.savetemp_row} col-md-12 savetemp_row`} id="savelayoutrow">
                                              <div className={this.props.language === 'AR' ? `${styles.saveTempradiobtn} col-md-3` : `${styles.saveTempradiobtn} col-md-4`} id="saveradiobtn">
                                                <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`} htmlFor="radiobtn1">
                                                  <input type="radio" checked={this.state.radioBtnFlag === true} value={true} name="group2" className="col-md-2" onChange ={this.onchangeTemplateRadioBtn} id="radiobtn1"/>
                                                  <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                                                </label>
                                                <span className={`${styles.saveP} saveP`} id="saveAstitle" >{i18next.t('saveAs')}:</span>
                                              </div>
                                              <div className={this.props.language === 'AR'? `${styles.divInput} col-md-9`:`${styles.divInput} col-md-8`} id="saveAsinputbox">
                                                <input type="text" ref="templateName" placeholder={i18next.t("layoutName")} className="form-control"  maxLength="50" disabled={this.state.radioBtnFlag===false }/>
                                              </div>
                                            </div>

                                            {this.state.savelayouterror === true ?
                                              <div className="col-md-offset-4 col-md-8">
                                                <p className="errorPara" style={{marginTop:2, marginLeft:5, textAlign:'center', color:'red', fontSize:12, fontWeight:600, float:'left'}}>{i18next.t(this.state.errorMsg)}</p>
                                              </div>
                                            : null}

                                            <div className={`${styles.savetemp_row} col-md-12 savetemp_row`} id="updatelayoutrow">
                                              <div className={this.props.language === 'AR'? `${styles.saveTempradiobtn} col-md-3`:`${styles.saveTempradiobtn} col-md-4`} id="updateradiobtn">
                                                <label className={`cust-circle `+(this.props.userDetail.selectedTheme)+`_cust-circle`} htmlFor="radiobtn2">
                                                  <input type="radio" checked={this.state.radioBtnFlag === false} value={false} name="group2" className="col-md-2" onChange ={this.onchangeTemplateRadioBtn} disabled={this.props.tempList.length===0} id="radiobtn2"/>
                                                  <span className={`checkR `+(this.props.userDetail.selectedTheme)+`_checkR`}></span>
                                                </label>
                                                <span className={`${styles.saveP} saveP`} id="updateTitle">{i18next.t('update')}:</span>
                                              </div>
                                              <div className={this.props.language === 'AR'? `${styles.divInput} tempListonlayout col-md-9`:`${styles.divInput} tempListonlayout col-md-8`} id="tmpListId">
                                                <ButtonToolbar>
                                                  <DropdownButton title={i18next.t(templateName)} className={`${styles.tempdropdown} menulayoutDropdown btnText`}  id="dropdown-size-medium" disabled={this.props.tempList.length===0|| this.state.radioBtnFlag===true }>
                                                    {this.state.templatelist.map((templates) => {
                                                      return (
                                                        <MenuItem eventKey={templates} className={`${styles.menuitem}`}  onClick={() =>this.templateSelection(templates,templates.N)}>{templates.N}</MenuItem>
                                                      );
                                                    })
                                                  }
                                                  </DropdownButton>
                                                </ButtonToolbar>
                                              </div>
                                            </div>
                                            {this.state.updatelayouterror === true ?
                                              <div className="col-md-offset-2 col-md-9">
                                                <p className="errorPara" style={{marginTop:2, marginLeft:50, textAlign:'center', color:'red', fontSize:12, fontWeight:600, float:'left'}}>{i18next.t(this.state.errorMsg)}</p>
                                              </div>
                                            : null}

                                            <div className={`${styles.Tempcheckbox} col-md-12 Tempcheckbox`}>
                                              <label className={styles.checkbox_inline}>
                                                <label className={`${styles.containerClass} cust-box`}>
                                                <input type="checkbox" className="checkbox" checked={this.state.defaultTempFlag} onChange={this.handleCheckboxChange}/>
                                                <span className={`${styles.checkmark} checkmark`}></span>
                                                </label>
                                                <span className={styles.checkmark}>
                                                  {i18next.t("saveAsDefaultLayout")}</span>
                                              </label>
                                            </div>

                                            <div className={`${styles.Savebutton_grp} col-md-12 Savebutton_grp`}>
                                              <Button onClick={this.onSaveTemplate} className={`${styles.savebutton} popbutton col-auto`} id="savelayoutbtn">{i18next.t('save')}</Button>
                                              <Button onClick={this.closeSaveOnLayout} className={`${styles.clearbutton} popbutton col-auto`} >{i18next.t('cancel')}</Button>
                                            </div>
                                          </div>
                                        : null}
                                        </div>
                                    : null}
                                          { this.state.showBiometricDvcsFlag === true ?
                                            this.state.biometricDevList.length !==0 ?
                                            this.state.biometricDevList.map((item,index) => {
                                              return (
                                                <React.Fragment>
                                                  <div className={`${styles.wrpRow}`}>
                                                      <div className={`${styles.bioRowContent} bioRowContent`}>
                                                        <p>{item.deviceName}</p>
                                                      </div>
                                                      <div className={`${styles.bioRowContent}`}>
                                                        <div className={`${styles.button_Content} button_Content`}>
                                                           <ButtonToolbar>
                                                             <Button id={"deRegBtn"+index} className={`${styles.savebutton} profileButton savebutton`} onClick={()=>this.deregisterConfirmation(item)}>Deregister</Button>
                                                           </ButtonToolbar>
                                                        </div>
                                                      </div>
                                                  </div>
                                                </React.Fragment>
                                              )})
                                              :
                                              <React.Fragment>
                                                <div className={`${styles.wrpRow} mt-3`}>
                                                <h4>{i18next.t('noDataAvlMsg')}</h4>
                                                </div>
                                              </React.Fragment>:null}
                                              
                                  </div>
                                </div>
                              </div>
                            </OutsideAlerter>
                          )}
                        </div>
                      </li>

                      {this.props.setLockState === 1 ?
                        <li onClick={() => this.lock()} id="settingMenu" className="lockDiv">
                          <div>
                            <span className={`${styles.iconsetting} menuIcon lock`}> </span>
                            <p className={styles.navItemLabel}>{i18next.t('lock')}</p>
                          </div>
                        </li>
                      :
                        <li id="settingMenu" className="lockDiv">
                          <div>
                            <span className="menuIcon unlock"> </span>
                            <p className={styles.navItemLabel}>{i18next.t('unlock')}</p>
                          </div>
                        </li>
                      }

                      <li id="settingMenu">
                        <div>
                          {parseInt(this.props.ratesStatus) === 0 && parseInt(this.props.orderStatus) === 0 ?
                            <span data-tip data-for='Tooltip1' className="menuIcon status">
                              <ReactTooltip id='Tooltip1' className='toolTip'>
                                <span>{dataTooltip1}</span>
                              </ReactTooltip>
                            </span>

                          : parseInt(this.props.ratesStatus) === 1 && parseInt(this.props.orderStatus) === 1 ?
                            <span data-tip data-for='Tooltip2' className="menuIcon status-down">
                              <ReactTooltip id='Tooltip2' className='toolTip'>
                                <span>{dataTooltip2}</span>
                              </ReactTooltip>
                            </span>

                          : parseInt(this.props.ratesStatus) === 2 && parseInt(this.props.orderStatus) === 2 ?
                            <span data-tip data-for='Tooltip3' className="menuIcon status-down">
                              <ReactTooltip id='Tooltip3' className='toolTip'>
                                <span>{dataTooltip3}</span>
                              </ReactTooltip>
                            </span>

                          : parseInt(this.props.ratesStatus) === 2 ?
                            <span data-tip data-for='Tooltip3' className="menuIcon status-down">
                              <ReactTooltip id='Tooltip3' className='toolTip'>
                                <span>{dataTooltip4}</span>
                              </ReactTooltip>
                            </span>

                          : parseInt(this.props.orderStatus) === 2 ?
                            <span data-tip data-for='Tooltip3' className="menuIcon status-down">
                              <ReactTooltip id='Tooltip3' className='toolTip'>
                                <span>{dataTooltip5}</span>
                              </ReactTooltip>
                            </span>

                          : parseInt(this.props.ratesStatus) === 1 ?
                            <span data-tip data-for='Tooltip3' className="menuIcon status-down">
                              <ReactTooltip id='Tooltip3' className='toolTip'>
                                <span>{dataTooltip6}</span>
                              </ReactTooltip>
                            </span>

                          : parseInt(this.props.orderStatus) === 1 ?
                            <span data-tip data-for='Tooltip3' className="menuIcon status-down">
                              <ReactTooltip id='Tooltip3' className='toolTip'>
                                <span>{dataTooltip7}</span>
                              </ReactTooltip>
                            </span>
                          : null}

                          <p className={styles.navItemLabel}>{i18next.t('status')}</p>
                        </div>
                      </li>

                      <li onClick={this.onClickLogout} id="settingMenu">
                        <div>
                          <span className="menuIcon unlock"><img width="40px" src="images/logout.png"/></span>
                          <p className={styles.navItemLabel}>{i18next.t('logout')}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </nav>

            <div className="subHeader">
              <div className="row justify-content-between">
                <div className="col-xs-4">
                  <span className="subHeaderLbl">{i18next.t("login")}:</span> {LoggedInTimeDate}
                </div>

                <div className="col-xs-7 text-right">
                  <span className="subHeaderLbl">{i18next.t("trader")}:</span> {show_trdDetails}
                    &nbsp; | &nbsp;
                  <span className="subHeaderLbl">{i18next.t("account")}:</span> {this.state.defAcc}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={this.props.forcedLogout} className={styles.tmpl_content} contentLabel="Example Modal" id="menuSettingModal" onAfterOpen={this.afterOpenModal}>
          <div ref="errorMSG" className={`${styles.forcedLogoutDiv} mdlWrap`} >
            <div className={styles.forceHeader}>
              <span className={styles.forceMsgTitle}>{i18next.t("alert")}</span>
              <span className={`${styles.closeicon}`} id="closeModalIcon" onClick={this.handleLogout}>
                {closeIcon}
              </span>
            </div>

            <div className={styles.forceReLogDiv}>
              <h5>{i18next.t('trdSettingChanged')}</h5>
            </div>
            <Button onClick={this.handleLogout} className={`${styles.tmp_popbutton} col-md-offset-4 col-md-4 popbutton`} id="tmpSaveCancel">{i18next.t('OK')}</Button>
          </div>

          {/*<p>{i18next.t('Do you want to save template?')}</p>
          <div className={`${styles.tmp_button_grp} col-md-12`}>
          <Button onClick={this.saveTemplatebyForced} className={`${styles.tmp_popbutton} col-md-5`} id="tmpSaveConfirm">{i18next.t('Yes')}</Button>
          </div>*/}
        </Modal>

        {this.props.checkLockFlag === true ?
          <Modal isOpen={this.props.unlockScreenFlag} className={`${styles.content} ${styles.unlockpopup}`} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.widgetHeader} widgetHeader`}>
                <span className="widgetTitle">{i18next.t('unlockScreen')}</span>
                <span onClick={this.closeunlockModal} className={`${styles.closeicon}`} id="unlockScreenCloseIcon">
                  {closeIcon}
                </span>
              </div>
              {/*<div className={`${styles.passwordDiv} pwdDiv`}>*/}

              <div className={`${styles.save_row} row pwdDiv`}>
                <div className={`${styles.passWrdLbl} col-auto passLabel`}>
                  <span>{i18next.t('pwd')}:</span>
                </div>
                <form onSubmit={this.preventSubmit} className={`${styles.divInput} col passInput`} autoComplete="off">
                  <input type="password" onKeyUp={this.onKeyUp} onKeyPress={this.onKeyPress} ref="enterpass" placeholder={i18next.t("pwd")} className="form-control" autoComplete="new-password" autoFocus/>
                </form>
              </div>

              {this.state.errorMsg !== "" ?
                <div className={`${styles.unlockErrDiv} row`}>
                  <div className="col-md-10">
                    <p>{i18next.t(this.state.errorMsg)}</p>
                  </div>
                </div>
              : null}

              <div className="row justify-content-center lockBtnDiv">
                <Button onClick={this.handleUnlock} className={`${styles.savebutton} userMenuList col-auto`} id="unlockScreenModal">{i18next.t('unlock')}</Button>
                <Button onClick={this.closeunlockModal} className={`${styles.clearbutton} userMenuList col-auto`} id="unlockScreenCncle">{i18next.t('cancel')}</Button>
              </div>

              {/*</div>*/}
            </div>
          </Modal>
        : null}

        {this.props.logoutFlag === true ? <LogoutComponent/> : null}

        <Modal id="versionHist" isOpen={this.state.versionModal} className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
          <div ref="errorMSG" className="mdlWrap" >
            <div className={`${styles.widgetHeader} widgetHeader`}>
              <span className={`${styles.widgetTitle} widgetTitle`}>Release Notes</span>
              <span onClick={this.closeVersionModal} className={`${styles.closeImg} closeIcon commonCloseIcon`}>
                {closeIcon}
              </span>
            </div>

            <div className={`msg commonMsgDir`}>
              <Version />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

//const MenuBarComponentWithClick = withClickOutside(MenuBarComponent, 'profileWrapper');
//export default MenuBarComponentWithClick;
export default MenuBarComponent;
